import React from 'react';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs as MUIBreadcrumbs } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link } from 'daaas-ui';
import { useLocation } from 'react-router-dom';

export default function Breadcrumbs() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => {
    const removePaths = [
      '',
      'data-analytics-services',
      'services-analyse-donnees',
      'overview',
      'apercu',
    ];
    return !removePaths.includes(x);
  });

  const breadcrumbNameMap = {
    aaw: t('aaw'),
    etaa: t('aaw'),
    cae: t('cae'),
    eac: t('cae'),
    gae: t('gae'),
    eag: t('gae'),
    hub: t('hub'),
    guichet: t('hub'),
    faq: t('faq'),
    'vdl-hub': t('vdlHub'),
    'guichet-lvd': t('vdlHub'),
  };

  return (
    <MUIBreadcrumbs
      aria-label={t('daaasBreadCrumbCanadaca')}
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: 0 }}
    >
      <Link variant="subtitle1" href={`${t('common:hrefStatcanStart')}`}>
        {t('home')}
      </Link>
      {pathnames.length !== 0 && (
        <Link
          variant="subtitle1"
          href={`${t('common:/urlPrefix')}${t('common:/overview')}`}
        >
          {t('daaas')}
        </Link>
      )}
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;
        const to = `${t('common:/urlPrefix')}/${pathnames.slice(0, index + 1).join('/')}`;

        return (
          !last && (
            <Link variant="subtitle1" href={to} key={to}>
              {breadcrumbNameMap[value]}
            </Link>
          )
        );
      })}
    </MUIBreadcrumbs>
  );
}
